/**
 * Created by rhillion on 01/07/2017.
 */

import firebase from 'firebase'
var config = {
    apiKey: "AIzaSyAz5LLxYUa1NhlCFWUQWYj1fUV8jkRGWR8",
    authDomain: "callmelocal-e6c2b.firebaseapp.com",
    databaseURL: "https://callmelocal-e6c2b.firebaseio.com",
    projectId: "callmelocal-e6c2b",
    storageBucket: "callmelocal-e6c2b.appspot.com",
    messagingSenderId: "1090612475506"
};
firebase.initializeApp(config);

export const firebaseDB = firebase.database()
export const firebaseAuth = firebase.auth
export const firebaseStorage = firebase.storage()


// WEBPACK FOOTER //
// ./src/helpers/fire.js